import { makeStyles } from '@material-ui/core';

const useStyle = makeStyles((theme)=>({
    Grid:{
        padding:'40px'
    }
}));

export default useStyle;